import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import "react-toastify/dist/ReactToastify.css";
import CssBaseline from "@mui/material/CssBaseline";
import reportWebVitals from "./reportWebVitals";

import Main from "./Main";
import "./i18n.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <Main />
  </React.StrictMode>
);
reportWebVitals();
